import(/* webpackMode: "eager" */ "/home/ubuntu/download/697588511beda8001461464f/incuba_ai/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697588511beda8001461464f/incuba_ai/src/app/contact/components/ConsultationBooking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697588511beda8001461464f/incuba_ai/src/app/contact/components/PartnershipInquiry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/697588511beda8001461464f/incuba_ai/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/697588511beda8001461464f/incuba_ai/src/components/ui/AppIcon.tsx");
